module.exports = __webpack_public_path__ + "static/media/recording.dcbfc337.jpg";